import React, { useState, useEffect } from 'react';
import api from '../utils/axios';
import { useAuth } from '../context/AuthContext';
import './AIInfoScreen.css';

const PLACEHOLDER_DEMO = 'Bijvoorbeeld: Offerte voor schilderen van een huis, binnenkant, wanden, kozijnen, deuren.';
const PLACEHOLDER_REAL = "Bijvoorbeeld: Offerte voor een website van 5 pagina's en hosting.";

const AIInfoScreen = ({ onDataReceived, onSkip, onBack, initialQuery = '' }) => {
  const { user } = useAuth();
  const isDemo = user?.isDemo === true;
  const [query, setQuery] = useState(initialQuery);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Als initialQuery verandert (bijv. opmerkingen uit API-aanvraag), vul het tekstveld bij
  useEffect(() => {
    if (initialQuery && initialQuery !== query) {
      setQuery(initialQuery);
    }
  }, [initialQuery]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const response = await api.post('/api/offertegpt/query', {
        query: query
      });

      // Process the response and pass to quotation builder
      onDataReceived({
        query: query,
        response: response.data,
        timestamp: new Date().toISOString()
      });
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to connect to Offertegpt. Please check your connection.');
      console.error('Offertegpt error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ai-info-screen">
      <div className="container">
        <div className="header">
          <h1 className="logo">OfferteRunner</h1>
          <p className="tagline">Slimmer groeien met AI & creativiteit</p>
        </div>

        <div className="card main-card">
          <h2>AI Informatie Invoer</h2>
          <p className="subtitle">Verbind met Offertegpt om een offerte te genereren</p>

          {error && <div className="error">{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="input-group" data-demo-step="demo-step-2">
              <label htmlFor="query">Voer uw vraag of informatie in:</label>
              <textarea
                id="query"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder={isDemo ? PLACEHOLDER_DEMO : PLACEHOLDER_REAL}
                required
                rows={6}
              />
            </div>

          <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
            <button 
              type="submit" 
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? 'Verbinding maken...' : 'Verbind met Offertegpt'}
            </button>
            {onSkip && (
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => {
                  onSkip();
                }}
              >
                Sla over → Direct naar Volgende Stap
              </button>
            )}
          </div>
          </form>

          <div className="info-box">
            <h3>Hoe werkt het?</h3>
            <ol>
              <li>Voer uw projectinformatie of vraag in</li>
              <li>OfferteRunner verbindt met Offertegpt om de informatie te verwerken</li>
              <li>Genereer een professionele PDF-offerte</li>
              <li>Stuur de offerte direct naar Odoo CRM</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AIInfoScreen;
